import { defineStore } from 'pinia'

export const useHeaderStore = defineStore('header', {
  state: () => (
      {
        header : {
          title: "",
          backLink: null,
          back: false,
          link: "/",
          removeClose: false
        }
      }
  ),
  getters: {
    // doubleCount: (state) => state.count * 2,
  },
  actions: {
    setHeaderData(back,title,backLink,remove){
      this.header.back = back;
      this.header.backLink = backLink;
      this.header.title = title;
      this.header.removeClose = remove;
    },
    setTitle(text) {
      this.header.title = text;
    },
    showBackButton(bool) {
      this.header.back = bool;
    }
  },

})
